import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { ContentCard, QuickTransferModal, BulkUploadModal } from '../../Common';
import { handleApiExceptions, generate_query_set, alertify } from '../../../app_methods';
import { transfersApprovalTableFilterNodes } from './constants';
import { TransferRequestApproval } from '../../../models';
import { connect } from 'react-redux';
import { Menu, Dropdown, Icon, Descriptions, Badge, Button, Alert,Tooltip } from 'antd';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { APPROVAL_FLOW_STATUS_TYPES } from '../../../constants';
import { Text4 } from '../../../styles';
import { ApprovalDetailsDrawer } from './details_drawer';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';
import { ApprovalConfigModal } from '../../Common';
import { MerchantService } from '../../../services';
import { updateCurrentUserAction } from '../../../redux/actions';
import moment from 'moment';
import { printRupee } from '../../../app_methods'
import FileSaver from 'file-saver';


const PermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_WRITE",{ is_component: true, fallbackComponent: null })
const TransfersPermissableButton = PermissionHoc(Button,"TRANSFERS_READ",{ is_component: true, fallbackComponent: null })
const WritePermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_WRITE",{ is_component: true, fallbackComponent: null })
const ReadPermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_READ",{ is_component: true, fallbackComponent: null })

const TransferRequestApprovalList = (props) => {
    const [transferApprovals, setTransferApprovals] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ["10", "25", "50", "100"],
        showTotal: (total) => `Total ${total} Records`
    });
    const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
    const [selectedTransferRequestApproval, setSelectedTransferRequestApproval] = useState({})
    const [showApprovalConfigModal, setShowApprovalConfigModal] = useState(false);
    const [isSaving, setIsSaving] = React.useState(false);
    const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const user_level=props.current_user?.user?.level

    let filterNodes = transfersApprovalTableFilterNodes();


    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const setDefaultFilters=()=>{
        let _filters = {  };
        let batch_id = "";
        let defaultFilters = {};
        filterNodes.forEach(f => defaultFilters[f.field] = f.defaultValue);
        _filters = { ..._filters, ...defaultFilters };
        return _filters;
    }


    const [filters, setFilters] = useState(setDefaultFilters());
    const isMerchant = props.current_user.user ? !props.current_user.user.id || props.current_user.user.email ==  props.current_user.email : false
    const isAdmin = props.current_user.user? props.current_user.user.is_admin : false;

    const toggleApprovalConfigModal = () => {
        setShowApprovalConfigModal(!showApprovalConfigModal)
    }

     const toggleDetailsDrawer = (approvalRequest = {}) => {
        setSelectedTransferRequestApproval(approvalRequest);
        setShowDetailsDrawer(!showDetailsDrawer);
    };


    const fetchTransferApprovals = async (_pagination=pagination, _filters=filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await TransferRequestApproval.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(TransferRequestApproval, response.data.results)
        if (selectedTransferRequestApproval.id) {
            var selectedData = queryset.find(transferRequestApproval => transferRequestApproval.id == selectedTransferRequestApproval.id) || {}
            setSelectedTransferRequestApproval(selectedData);
        }
        setTransferApprovals(queryset)

        setPagination({ ...pagination, total: response.data.count });
        setIsTableLoading(false);
    };
   
    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchTransferApprovals(_pagination, tableInfo.filters);
    };

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const updateApprovalConfig = async (data = {}) => {
        setIsSaving(true);
        const response = await MerchantService.update_transfer_request_approval_config(data)
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        fetchMerchantInfo();
        toggleApprovalConfigModal(false)
        setIsSaving(false);
        alertify("Success", "Config updated successfully", "success");
    }


    const approveRequest = async (approvalRequest = {}, declined=false) => {
        setIsTableLoading(true);
        setIsLoading(true);
        setSelectedTransferRequestApproval({...approvalRequest,processing:true});
        const response = await approvalRequest.approve_request({declined: declined});
        if (!response.success) {
            setIsTableLoading(false);
            setIsLoading(false);
            fetchTransferApprovals(pagination,filters)
            handleApiExceptions(response);
            return;
        }
        setIsTableLoading(false);
        fetchTransferApprovals(pagination, filters);
        var message = declined ? 'Rejected' : 'Approved'
        alertify("Success", `Request ${message} Successfully.`, "success");
    }

    useEffect(() => {
        props.onChildMount();
        fetchTransferApprovals(pagination, { ...filters });
    }, []);

    // const tableColumns = getTransfersApprovalTableColumns({ setShowStatusInfoDrawer: setShowStatusInfoDrawer, toggleDetailsDrawer: toggleDetailsDrawer, approveRequest: approveRequest, isMerchant: isMerchant, user_level: props.current_user.user?props.current_user.user.level: '' ,filters});

    const downloadReport = async () => {
        setIsDownloading(true)
        const prepedfilters=prepFilters(filters)
        const response = await TransferRequestApproval.downloadApprovalReport(prepedfilters);
        setIsDownloading(false)
        if (!response?.data?.type) {
            handleApiExceptions(response);
            return;
          }
        FileSaver.saveAs(response.data, `Approval_Report.csv`);
        
      };

    const getTransfersApprovalTableColumns = () => [{
        title: "Created At",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
    }, {
        title: "URN",
        key: "unique_request_number",
        render: (record) => <Text4>{record.transfer_request? record.transfer_request.unique_request_number: '---'}</Text4>
    }, {
        title: "Transfer Amount",
        key: "amount",
        render: (record) => <Text4>{printRupee(record.amount)}</Text4>
    },
    {
        title: "Requested By",
        key: "requested_by",
        render: (record) => <Text4>{record.requested_by}</Text4>
    },
    {
        title: <span className="c-pointer" onClick={setShowStatusInfoDrawer}><span>Status</span><Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" /></span>,
        key: "status",
        render: (record) =>
            <div>
                {
                    <div>
                        <Badge color={APPROVAL_FLOW_STATUS_TYPES[record.status].color} text={<Text4>{APPROVAL_FLOW_STATUS_TYPES[record.status].label}</Text4>} />
                    </div>
                }
            </div>
    },
    {
        title: "Approval",
        key: "status",
        render: (record) =>
            <div>
                {record.approvals_required.map(level =>{
                    return <Text4 style={{marginRight: 10}}>{record.approved_levels.includes(level)?
                        <Tooltip title="Approved" className="mr-1"><Icon type="check-circle" style={{color: 'green'}} /></Tooltip>:
                        record.declined_levels.includes(level)?<Tooltip title="Rejected" className="mr-1"><Icon type="close-circle" style={{color: 'red'}}/></Tooltip>:
                        <Tooltip title="Pending for approval" className="mr-1"><Icon type="exclamation-circle" style={{color: 'orange'}}/></Tooltip>}{level}</Text4>
                }
    
                )}
            </div>
    },
    {
        title: "Actions",
        render: (record) => <>
            {
            record.status == 'approved' || record.status == 'rejected' || record.status == 'cancelled' || isMerchant ?'---':
            !record.approved_levels.includes(user_level)  && !record.declined_levels.includes(user_level) ?
            <>
            <WritePermissableButton type="primary" className="mr-1" size="small" onClick={() => {approveRequest({ ...record },false)}} ghost>Approve</WritePermissableButton>
            <WritePermissableButton type="danger" className="mr-1" size="small" onClick={() => approveRequest({ ...record }, true)} ghost>Reject</WritePermissableButton>
            </>
            : '---'
            }
        </>
    }
    ];

    return (
        <ContentCard className="p-3">
            {props.current_user.eta?
            <>
                <div className="w-100 d-flex justify-content-end">
                {isMerchant || isAdmin ? <PermissableButton type="primary" onClick={toggleApprovalConfigModal}>
                     Approval Flow Config
                </PermissableButton>: null}
                <TransfersPermissableButton type="primary" style={{marginLeft: "10px"}} ghost onClick={() => props.redirect('/transfers')}>Transfers</TransfersPermissableButton>
            </div>
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={transferApprovals}
                columns={getTransfersApprovalTableColumns()}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                pagination={pagination}
                totalRecords={pagination.total}
                filterNodes={filterNodes}
                onRow={(record) => ({
                    onClick: (event) => {
                        if(event.target.nodeName != 'BUTTON')
                        toggleDetailsDrawer(record);
                    },
                })}
                downloadable={true}
                onDownload={downloadReport}
                isDownloading={isDownloading}
            />

            <ApprovalConfigModal
                visible={showApprovalConfigModal}
                toggleApprovalConfigModal={toggleApprovalConfigModal}
                approvalConfig={props.current_user.tac}
                onSubmit={updateApprovalConfig}
                loading={isSaving}
            />

            <ApprovalDetailsDrawer
                visible={showDetailsDrawer}
                toggleDetailsDrawer={toggleDetailsDrawer}
                approvalRequest={selectedTransferRequestApproval}
                onApprove={approveRequest}
                user_level={props.current_user.user?props.current_user.user.level: ''}
                isMerchant={isMerchant}
                merchant={props.current_user}
                loading={isTableLoading}
                fetchTransferApprovals={fetchTransferApprovals}
            />

            

            <EaseDrawer
                visible={showStatusInfoDrawer}
                onClose={() => setShowStatusInfoDrawer(false)}
                hideFooter
                title="Transfer Request Approval Statuses"
                width={500}
            >
                <Descriptions bordered className="mt-3" size="small" layout="horizontal" column={1}>
                    {
                        Object.keys(APPROVAL_FLOW_STATUS_TYPES).map((key, index) => {
                            return <Descriptions.Item label={<Badge color={APPROVAL_FLOW_STATUS_TYPES[key].color} text={<Text4>{APPROVAL_FLOW_STATUS_TYPES[key].label}</Text4>} />}>
                                {APPROVAL_FLOW_STATUS_TYPES[key].description}
                            </Descriptions.Item>
                        })
                    }
                </Descriptions>
            </EaseDrawer>
            </>:
            <Alert
              message="Error"
              description="You are not authorised to view this page."
              type="error"
              showIcon
            />
            }

        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(TransferRequestApprovalList, 'APPROVAL_FLOW_READ'));